import { CustomerSubscriptionAvailabilityClient } from './subscriptionAvailability.client';
import { CustomerSubscriptionAvailabilityModel } from './subscriptionAvailability.model';

export async function customerSubscriptionAvailabilityProvider(
  courseId: string
): Promise<CustomerSubscriptionAvailabilityModel> {
  const response = await new CustomerSubscriptionAvailabilityClient(
    courseId
  ).get();

  return response as unknown as Promise<CustomerSubscriptionAvailabilityModel>;
}
